import { SORT_OPTIONS_ENUM } from 'src/constants'

type RemapSortOptionForNovasolV2Props = {
  sortOption: string
  datedSearch: boolean
}

export const remapSortOptionForNovasolV2 = ({
  sortOption,
  datedSearch,
}: RemapSortOptionForNovasolV2Props): string => {
  if (!datedSearch) {
    if (sortOption === 'priceasc') {
      return SORT_OPTIONS_ENUM.RECOMMENDED
    }

    if (sortOption === 'pricedsc') {
      return SORT_OPTIONS_ENUM.REVIEWS_DESCENDING
    }
  }

  if (sortOption === 'bestmatch') {
    return SORT_OPTIONS_ENUM.RECOMMENDED
  }

  if (sortOption === 'gradedsc') {
    return SORT_OPTIONS_ENUM.REVIEWS_DESCENDING
  }

  return sortOption
}
